import RoutesHelper from 'helpers/routes';
import { Navigate } from 'react-router-dom';

function ObservationVideos() {
  return <Navigate replace to={RoutesHelper.getPath('measure')} />;
}

export default ObservationVideos;
